import type { CreditScoreRange } from './types/CreditScoreRange';
import type { RatesForBrand } from './types/RatesForBrand';
import { creditScoreRangeArray } from './creditScoreRangeArray';
import { isLoanTermRates } from './isLoanTermRates';

export const isRatesForBrand = (rate: unknown): rate is RatesForBrand => {
  if (typeof rate !== 'object' || rate === null) {
    return false;
  }

  const creditScores = Object.keys(rate) as CreditScoreRange[];

  if (creditScores.length === 0) {
    return false;
  }

  const isInCreditScores = (creditScore: CreditScoreRange) =>
    creditScores.includes(creditScore);

  if (!creditScoreRangeArray.every(isInCreditScores)) {
    return false;
  }

  const isLoanRates = (creditScore: CreditScoreRange) =>
    isLoanTermRates((rate as RatesForBrand)[creditScore]);

  return creditScores.every(isLoanRates);
};
